import { connect } from 'react-redux';

import OrderSummary from '../../components/order/summary';

const mapStateToProps = (state, ownProps) => ({
    order: state.order,
    placedOrder: ownProps.placedOrder,
    currentCheckoutStep: state.currentCheckoutStep,
    locale: state.locale.currentLocale,
});

const mapDispatchToProps = (dispatch) => ({});

const OrderSummaryConnector = connect(mapStateToProps, mapDispatchToProps)(OrderSummary);

export default OrderSummaryConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/order/summary-connector.js
 **/